import { useStorefrontSummary } from '../hooks/useStorefrontSummary';
import { useStoreHealth, useStoreHealthTrend } from '../hooks/useStoreHealth';
import { StorefrontSummaryCard } from '../components/StorefrontSummaryCard';
import { ScoreDistributionChart } from '../components/ScoreDistributionChart';
import { CommonIssuesList } from '../components/CommonIssuesList';
import { SyncPanel } from '../components/SyncPanel';
import { StoreHealthCard } from '../components/StoreHealthCard';
import { StoreStatusCard } from '../components/StoreStatusCard';
import { LowStockCard } from '../components/LowStockCard';
import { WeeklyTrendsCard } from '../components/WeeklyTrendsCard';
import { KpiTrendChart } from '../components/KpiTrendChart';

export function DashboardPage() {
  const { data, isLoading } = useStorefrontSummary();
  const { data: healthData } = useStoreHealth();
  const { data: trendData } = useStoreHealthTrend();

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">Dashboard</h2>

      <div className="card p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Catalog Sync</h3>
        <SyncPanel />
      </div>

      {healthData && <StoreHealthCard data={healthData} />}

      <StoreStatusCard />

      <div className="grid gap-6 lg:grid-cols-2">
        <LowStockCard />
        <WeeklyTrendsCard />
      </div>

      {trendData?.snapshots && trendData.snapshots.length >= 2 && (
        <KpiTrendChart snapshots={trendData.snapshots} />
      )}

      {isLoading && <div className="text-center py-8 text-gray-500">Loading store summary...</div>}

      {data && (
        <>
          <StorefrontSummaryCard data={data} />

          <div className="grid gap-6 lg:grid-cols-2">
            <div className="card p-6">
              <h3 className="text-lg font-medium text-gray-900 mb-4">Score Distribution</h3>
              <ScoreDistributionChart distribution={data.scoreDistribution} />
            </div>

            <div className="card p-6">
              <h3 className="text-lg font-medium text-gray-900 mb-4">Common Issues</h3>
              <CommonIssuesList issues={data.commonIssues} />
            </div>
          </div>

          {data.analyzedProducts > 0 && (
            <div className="card p-6">
              <p className="text-sm text-gray-600">
                {data.analyzedProducts} / {data.totalProducts} products analyzed
              </p>
            </div>
          )}
        </>
      )}

      {!isLoading && !data && (
        <div className="card p-6 text-center text-gray-500">
          No data yet. Sync your catalog and run an analysis to get started.
        </div>
      )}
    </div>
  );
}
